import React, { useEffect } from 'react';
import ProductGallery from '@components/molecules/products/product-gallery/product-gallery';
import ProductLikeButton from '@components/atoms/product-like-button/product-like-button';
import { useAnalytics } from '@context/analytics.context';
import { NegotiationProvider } from '@context/negotiation.context';
import getCatalogQueryIndex from '@helpers/utils/catalog-query-index';
import { usePreferences } from '@context/preferences.context';
import useProductQuery from '@hooks/product/use-product-query';
import ProductSchema from '@components/structured-schemas/product-schema';
import useCatalogPageMetadataQuery from '@hooks/catalog-context/use-catalog-page-metadata-query';
import useFeatureFlag from '@hooks/use-feature-flags';
import styles from './hero-pdp.module.scss';
import HeroPDPDetails from './hero-pdp-details/hero-pdp-details';

type HeroPDPProps = {
  includeProductSchema?: boolean;
};

const HeroPDP: React.FC<HeroPDPProps> = ({ includeProductSchema = true }): React.JSX.Element => {
  const { country } = usePreferences();
  const { updateDataLayer } = useAnalytics();
  const { product } = useProductQuery();
  const { catalogMetadata } = useCatalogPageMetadataQuery();
  const { isSemPDP } = useFeatureFlag();

  useEffect(() => {
    if (!product) {
      return;
    }

    updateDataLayer({
      catalog_version: 'hero pdp',
      event: '',
      keyword: 'no keyword',
      index_name: getCatalogQueryIndex(country, 'relevance'),
      env_template: 'catalog',
      product_univers: product?.universe?.name,
      product_category: product?.category?.name,
      product_subCategory: product?.subcategory,
      product_brand: product?.brand?.name,
      product_id: product?.id,
      product_name: product?.name,
      pageUrl: window.location.href,
      // to fix with similar product products.slice(0, 3)
      list_products: [],
      profilId: product?.seller.id,
      screen_name: '/search_results/hero_pdp',
      screen_subcategory: 'search_results',
      screen_category: 'search',
      ...(isSemPDP && {
        catalog_version: 'hero pdp',
        screen_name: '/product/sem_pdp',
        screen_category: 'product',
        screen_subcategory: 'product',
        env_template: 'product',
      }),
    });
  }, [product]);

  return (
    <div className={styles.heroPDP}>
      {includeProductSchema && (
        <ProductSchema
          product={product}
          seoMetaData={catalogMetadata?.metadata}
        />
      )}
      <div className={styles.heroPDP__gallery}>
        <ProductGallery
          contextCssClass={styles.heroPDP__gallery__images}
          pictures={product?.pictures}
          productPath={product?.path}
          defaultAlt={`${product.name} ${product?.brand?.name}`}
        />
        <ProductLikeButton
          customClass={styles.heroPDP__gallery__likeBtn}
          testIdSuffix="_hero"
          product={product}
          showText={false}
          pageType="product_page"
        />
      </div>
      <NegotiationProvider>
        <HeroPDPDetails />
      </NegotiationProvider>
    </div>
  );
};

export default HeroPDP;
